import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

/**
 * Advertising platforms that are not yet generally available. They are hidden
 * in the dealer advertising settings behind the `ADVERTISEMENT_NEW_PLATFORMS`
 * feature flag until ready for rollout. Add a platform code here to gate it.
 */
export const NEW_ADVERTISING_PLATFORM_CODES: string[] = [
  AdvertisingPlatformCodeEnum.AUTOSCOUT24,
  AdvertisingPlatformCodeEnum.VROOM,
  AdvertisingPlatformCodeEnum.CARFLOW,
  AdvertisingPlatformCodeEnum.TCS,
  AdvertisingPlatformCodeEnum.SPOTICAR,
  AdvertisingPlatformCodeEnum.TOYOTA_UCL,
  AdvertisingPlatformCodeEnum.TWO_DEHANDS,
  AdvertisingPlatformCodeEnum.LUXAUTO,
  AdvertisingPlatformCodeEnum.MYCAR_LU,
  AdvertisingPlatformCodeEnum.HEXON,
  AdvertisingPlatformCodeEnum.FASTBACK_B2B,
];
